import { bianka } from '@fiverr-private/obs';
import { StoreBuilder } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/store_builder';
import { AdditionalData, Click, ClickType } from '@fiverr-private/bianka_js';
import { ReportBiEventParams } from './reportBiEvent.types';

export const reportBiEvent = ({
    biEventData,
    activityType,
    eventType,
    elementName,
    elementType,
    store,
    pageName,
    tabbedCarouselTabClickData,
    storeBuilderToggleChoice,
}: ReportBiEventParams) => {
    const { userId, ctxId } = biEventData;

    const event: Click = {
        type: eventType,
        clickType: ClickType.UNSPECIFIED,
        ...(userId && { user: { id: userId } }),
        page: {
            name: pageName,
            ctxId,
            ...(storeBuilderToggleChoice && {
                referrer: {
                    name: storeBuilderToggleChoice,
                    ctxId,
                },
            }),
        },
        element: {
            name: elementName,
            type: elementType,
        },
    };

    bianka.reportActivity<Click, StoreBuilder>({
        type: activityType,
        event,
        ...((store || tabbedCarouselTabClickData) && {
            additionalData: {
                type: StoreBuilder,
                message: {
                    storeBuilderData: {
                        ...(store?.id && { id: store.id }),
                        ...(store?.userId && { userId: store.userId }),
                        ...(store?.niche && { niche: store.niche }),
                        ...(store?.banners && { banners: store.banners }),
                        ...(store?.storeUrl && { storeUrl: store.storeUrl }),
                        ...(store?.dropshipper && { dropshipper: store.dropshipper }),
                        ...(store?.appInstalled && { appInstalled: store.appInstalled }),
                        ...(store?.status && { status: store.status }),
                        ...(tabbedCarouselTabClickData && { tabbedCarousel: tabbedCarouselTabClickData }),
                    },
                },
            } as AdditionalData<StoreBuilder>,
        }),
    });
};
